<template>
  <v-card>
    <v-card-title>
      <v-icon class="mr-3">mdi-clock-fast</v-icon>
      Pikasuodatus
    </v-card-title>
    <v-card-subtitle class="pt-2">
      Pikasuodatus kiireisille ja niille, jotka eivät osaa käyttää
    </v-card-subtitle>
    <v-card-text>
      <v-autocomplete
        clearable
        :loading="loading_players"
        :items="league_players"
        no-data-text="Pelaajaa ei löydy"
        item-text="player_name"
        item-value="id"
        label="Lyöjä"
        @change="$event ? filter.hitters = [$event] : filter.hitters = null"
      />
      Tilanne
      <div class="d-flex justify-center">
        <v-btn
          :disabled="!filter.hitters || !filter.hitters.length"
          color="primary"
          v-for="tilanne in tilanteet"
          :key="'tilanne' + tilanne"
          class="ml-2"
          @click="handleSearch(tilanne)"
        >
          {{ tilanne }}
        </v-btn>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  created() {
    // Initialize all necessary data
    const promises = [
      this.initLeaguePlayers({ league_id: this.leagueId }),
      this.initSeasons(this.leagueId)
    ];

    Promise.all(promises)
      .then(([, seasons]) => {
        if (seasons && seasons.length > 0) {
          this.filter.season = seasons[0].id;
        }
      })
      .catch(error => {
        console.error('Error initializing QuickFilter data:', error);
        this.error('Virhe tietojen lataamisessa');
      });
  },
  data: () => ({
    tilanteet: ['0', '1', '1-2', 'Ajo'],
    filter: {
      hitters: null,
      bases_state: null,
      season: null
    }
  }),
  computed: {
    ...mapGetters('user', [
      'leagueId'
    ]),
    ...mapGetters('admin', [
      'league_players',
      'loading_players',
      'seasons'
    ]),
    ...mapGetters('user', [
      'currentTeamId'
    ])
  },
  methods: {
    ...mapActions('admin', [
      'initLeaguePlayers',
      'initSeasons'
    ]),
    ...mapActions('noti', [
      'error'
    ]),
    handleSearch(tilanne) {
      if (!this.filter.season || !this.filter.hitters) {
        this.error('Valitse ensin lyöjä ja kausi');
        return;
      }
      this.filter.bases_state = tilanne;
      this.$emit('search', { ...this.filter, save: false, league_id: this.leagueId, team_id: this.currentTeamId });
    }
  }
}
</script>